import { useTranslation } from 'react-i18next';
import styles from "./Chat3.module.css";

import ChatHeader from "../components/ChatComponents/ChatHeader";
import ChatBody from "../components/ChatComponents/ChatBody";
import ChatInput from "../components/ChatComponents/ChatInput";
import OldMessage from "../components/ChatComponents/OldMessage";
import av3 from "../assets/direct/av-fallback-3.jpg";

import ChatMessageTime from "../components/ChatComponents/ChatMessageTime";
import ChatMessageMe from "../components/ChatComponents/ChatMessageMe";
import ChatMessageOther from "../components/ChatComponents/ChatMessageOther";
import ChatAudioOther from "../components/ChatComponents/ChatAudioOther";
import ChatAudioMe from "../components/ChatComponents/ChatAudioMe";

export default function Chat3() {
  const { t } = useTranslation();
  
  return (
    <div className={styles.chatPageChat3}>
      <ChatHeader username="Ped*****" avatar={av3} status={t('direct.seenRecently')} />


      <ChatBody>
        {/* ===== MENSAGENS ANTIGAS (COM BLUR) ===== */}
        <OldMessage>
          <ChatMessageTime time="1 MÊS ATRÁS" />
          <ChatMessageOther text="Oi" />
          <ChatMessageMe text="Oi" />
          <ChatMessageOther text="Tudo bem?" showAvatar={false} />
          <ChatMessageMe text="Tudo" />
        </OldMessage>

        <OldMessage>
          <ChatMessageTime time="3 SEMANAS ATRÁS" />
          <ChatMessageOther text="Bom dia" />
          <ChatMessageMe text="Bom dia" />
          <ChatMessageOther text="Como foi seu dia?" showAvatar={false} />
          <ChatMessageMe text="Foi bom" />
        </OldMessage>

        <OldMessage>
          <ChatMessageTime time="2 SEMANAS ATRÁS" />
          <ChatMessageOther text="E aí" />
          <ChatMessageMe text="Oi" />
          <ChatMessageOther text="Que faz?" showAvatar={false} />
          <ChatMessageMe text="Nada" />
        </OldMessage>

        <OldMessage>
          <ChatMessageTime time="10 DIAS ATRÁS" />
          <ChatMessageOther text="Boa noite" />
          <ChatMessageMe text="Boa noite" />
        </OldMessage>

        <OldMessage>
          <ChatMessageTime time="1 SEMANA ATRÁS" />
          <ChatMessageOther text="Oi amor" />
          <ChatMessageMe text="Oi bb" />
          <ChatMessageOther text="Saudades" showAvatar={false} />
          <ChatMessageMe text="Tbm" />
        </OldMessage>

        <OldMessage>
          <ChatMessageTime time="6 DIAS ATRÁS" />
          <ChatMessageOther text="Bom dia" />
          <ChatMessageMe text="Bom dia" />
        </OldMessage>

        <OldMessage>
          <ChatMessageTime time="5 DIAS ATRÁS" />
          <ChatMessageOther text="Oi" />
          <ChatMessageMe text="Oi" />
          <ChatMessageOther text="Tá fazendo o que?" showAvatar={false} />
          <ChatMessageMe text="Nada" />
        </OldMessage>

        {/* ===== CONVERSA REAL (SEM BLUR) ===== */}
        
        {/* Áudios enviados */}
        <ChatAudioMe duration="0:13" />
        <ChatAudioMe duration="0:05" />

        {/* Áudio recebido */}
        <ChatAudioOther duration="0:20" />

        {/* Mensagem enviada */}
        <ChatMessageMe text={t('chats.chat3.okGoAhead')} />

        <ChatMessageTime time={`${t('chats.time.2daysAgo')}, 09:31`} />

        {/* Mensagens recebidas */}
        <ChatMessageOther text={t('chats.chat3.goodMorningBb')} />
        <ChatMessageOther text={t('chats.chat3.gotBetter')} showAvatar={false} />

        {/* Áudio enviado longo */}
        <ChatAudioMe duration="4:25" />

        {/* Mensagens enviadas */}
        <ChatMessageMe text={t('chats.chat3.sorryVenting')} />
        <ChatMessageMe text={t('chats.chat3.dontKnow')} />

        {/* Mensagem recebida */}
        <ChatMessageOther text={t('chats.chat3.dontWorry')} showAvatar={false} />

        {/* Áudios recebidos */}
        <ChatAudioOther duration="0:41" showAvatar={false} />
        <ChatAudioOther duration="0:12" showAvatar={false} />

        {/* Áudio enviado */}
        <ChatAudioMe duration="0:29" />

        {/* Mensagens recebidas */}
        <ChatMessageOther text={t('chats.chat3.yeahYouKnow')} showAvatar={false} />
        <ChatMessageOther
          text={t('chats.chat3.withSomeone')}
          blurWords={[t('chats.chat3.withSomeoneBlur')]}
          showAvatar={false}
        />
        <ChatMessageOther
          text={t('chats.chat3.fallingHard')}
          blurWords={[t('chats.chat3.fallingHardBlur')]}
          showAvatar={false}
        />

        {/* Áudios enviados */}
        <ChatAudioMe duration="0:04" />
        <ChatAudioMe duration="0:11" />

        {/* Mensagens recebidas */}
        <ChatMessageOther text={t('chats.chat3.lmao')} showAvatar={false} />
        <ChatMessageOther text={t('chats.chat3.talkLater')} showAvatar={false} />

      </ChatBody>

      <ChatInput />
    </div>
  );
}